"use client";

import styled from "styled-components";

interface FilterProps {
  $isOpen: boolean;
}

export const BoxFilterDate = styled.div`
  position: relative;
`;

export const ButtonFilter = styled.button`
  padding: 10px;
  border: 1px solid var(--primarySystem);
  border-radius: 0.5rem;
  background: var(--backgroundColorCard);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  svg {
    width: 18px;
    height: 18px;
    stroke: var(--textColor);
  }
`;

export const VisibilityInfo = styled.span`
  font-family: "Roboto Light";
  font-size: 14px;
  color: var(--textColor);
`;

export const BoxContentFilter = styled.div<FilterProps>`
  transition: all 0.3s;
  background: var(--backgroundColorCard);
  padding: 1rem;
  border-radius: 0.5rem;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 10px;
  width: min(18rem, calc(100vw - 2.5rem));
  z-index: 99;
  box-shadow: var(--shadowHoverCard);
  ${({ $isOpen }) =>
    $isOpen
      ? `
visibility: visible;
opacity: 1;
`
      : `
opacity: 0;
visibility: hidden;
`}

  @media (max-width: 768px) {
    left: 50%;
    transform: translateX(-50%);
    width: min(100%, calc(100vw - 2rem));
  }
`;
